import { useEffect, useState } from "react";
import { Loader2, Users, UserCheck, ListChecks, Activity } from "lucide-react";
import { api } from "@/lib/api";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";

function StatCard({ icon: Icon, label, value, accent }) {
  return (
    <div data-testid={`stat-${label}`} className="rounded-2xl border border-slate-200 bg-white p-5">
      <div className={`mb-2 inline-flex rounded-xl p-2 ${accent}`}><Icon className="h-5 w-5" /></div>
      <div className="font-mono-t text-3xl font-black text-zinc-950">{value}</div>
      <div className="text-xs font-semibold uppercase tracking-wide text-zinc-400">{label}</div>
    </div>
  );
}

export function AdminStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;

  return (
    <div className="space-y-6">
      <h2 className="font-display text-2xl font-extrabold uppercase text-zinc-950">Statistiche generali</h2>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <StatCard icon={Users} label="Iscritti totali" value={stats.total_users} accent="bg-green-100 text-green-700" />
        <StatCard icon={UserCheck} label="Attivi" value={stats.active_users} accent="bg-zinc-950 text-green-400" />
        <StatCard icon={ListChecks} label="Pronostici" value={stats.total_predictions} accent="bg-slate-100 text-zinc-700" />
        <StatCard icon={Activity} label="Partecipazione" value={`${stats.participation_rate}%`} accent="bg-green-100 text-green-700" />
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <p className="mb-4 text-sm font-bold uppercase tracking-wide text-zinc-500">Nuovi iscritti nel tempo</p>
        {stats.signups_over_time.length === 0 ? (
          <p className="py-10 text-center text-sm text-zinc-400">Ancora nessun dato.</p>
        ) : (
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={stats.signups_over_time}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="count" fill="#22c55e" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {stats.bookmaker_clicks && stats.bookmaker_clicks.length > 0 && (
        <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="stats-bookmaker-clicks">
          <p className="mb-4 text-sm font-bold uppercase tracking-wide text-zinc-500">Click "PROVA ORA" per bookmaker</p>
          <div className="space-y-2">
            {stats.bookmaker_clicks.map((b, i) => (
              <div key={i} className="flex items-center justify-between border-b border-slate-100 py-2 last:border-0">
                <span className="truncate pr-3 text-sm font-semibold text-zinc-800">{b.text}</span>
                <span className="font-mono-t font-black text-green-600">{b.clicks}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        <StatCard icon={ListChecks} label="Risposte totali" value={stats.total_answers} accent="bg-slate-100 text-zinc-700" />
        <StatCard icon={Users} label="Partecipanti unici" value={stats.participants} accent="bg-green-100 text-green-700" />
      </div>
    </div>
  );
}
